.toast {
  color: var(--color, var(--color-secondary));
  text-decoration: none;
  font-weight: 300;
  border-radius: 4px;
  padding: 12px 8px 12px 16px;
  border-left-color: var(--color-warning);
  border-left-width: 8px;
  border-left-style: solid;
  background-color: var(--color-warning-light-bg);
  z-index: 10;
  width: 398px;
  transition: opacity 0.3s ease-in all;
  box-sizing: border-box;
  box-shadow: 0 3px 1px -2px #0003, 0 2px 2px #00000024, 0 1px 5px #0000001f;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translate(-50%);
}

.close {
  width: 22px;
  height: 22px;
}

.close:hover {
  cursor: pointer;
}
